import type { PageMeta } from '#app'
import type { NavigationGuard } from 'vue-router'
import type { MiddlewareKey } from '#build/types/middleware'

export enum EPageMiddleware {
	AUTH = 'auth',
	NO_AUTH = 'no-auth',
	ADMIN_AUTH = 'admin-auth',
	ADMIN_NO_AUTH = 'admin-no-auth',
	ADMIN = 'admin',
	CMS = 'cms-permission',
}

export enum EPageLayout {
	PANEL = 'panel',
	MAIN = 'main',
	AUTH = 'auth',
	RESERVATION = 'reservation',
	DEFAULT = 'default',
	NAV = 'nav',
	ACCOUNT = 'account',
}

export const PageMiddlewareArrays: { [key: string]: (MiddlewareKey | NavigationGuard)[] } = {
	AUTH: [EPageMiddleware.AUTH],
	NO_AUTH: [EPageMiddleware.NO_AUTH],
	PANEL_AUTH: [EPageMiddleware.ADMIN_AUTH],
	PANEL_NO_AUTH: [EPageMiddleware.ADMIN_NO_AUTH],
	ADMIN: [EPageMiddleware.ADMIN_AUTH, EPageMiddleware.ADMIN],
	CMS: [EPageMiddleware.ADMIN_AUTH, EPageMiddleware.CMS],
}

export const pageMeta: { [key: string]: { [key: string]: PageMeta } } = {
	PANEL: {
		PANEL: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		PRODUCT_CATALOG: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
			title: 'CarFree',
		},
		PRODUCT_CATALOG_CARS_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		PRODUCT_CATALOG_SEGMENT: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		PARAMETERS: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		PARAMETERS_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		LOYALTY_PROGRAMS: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		DISCOUNT_CODES: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		DISCOUNT_CODES_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		LOCATIONS: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		LOCATIONS_ID: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		GOOGLE_RATINGS: {
			middleware: PageMiddlewareArrays.PANEL_AUTH,
			layout: EPageLayout.PANEL,
		},
		TRUSTPILOT_RATINGS: {
			middleware: PageMiddlewareArrays.PANEL_AUTH,
			layout: EPageLayout.PANEL,
		},
		LOGIN: {
			middleware: PageMiddlewareArrays.PANEL_NO_AUTH,
			layout: EPageLayout.AUTH,
		},
		LOGOUT: {
			middleware: PageMiddlewareArrays.PANEL_AUTH,
			layout: EPageLayout.AUTH,
		},
		REGISTER: {
			middleware: PageMiddlewareArrays.PANEL_NO_AUTH,
			layout: EPageLayout.AUTH,
		},
		NEWS: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		NEWS_CATEGORIES: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		AUTHORS: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		ADVANCE_RATE_PERIODS: {
			middleware: PageMiddlewareArrays.ADMIN,
			layout: EPageLayout.PANEL,
		},
		NEWS_ID: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		CMS_LOCATIONS: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		MEGA_MENU: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		CACHE_REVALIDATION: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		SUBPAGES: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
		SUBPAGES_ID: {
			middleware: PageMiddlewareArrays.CMS,
			layout: EPageLayout.PANEL,
		},
	},
	AUTH: {
		LOGIN: {
			middleware: PageMiddlewareArrays.NO_AUTH,
			layout: EPageLayout.AUTH,
		},
		LOGOUT: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.AUTH,
		},
		REGISTER: {
			middleware: PageMiddlewareArrays.NO_AUTH,
			layout: EPageLayout.AUTH,
		},
		SIGN_IN: {
			middleware: PageMiddlewareArrays.NO_AUTH,
			layout: EPageLayout.NAV,
		},
		ACCOUNT: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.ACCOUNT,
		},
		ACCOUNT_DATA: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.ACCOUNT,
		},
		ACCOUNT_ORDERS: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.ACCOUNT,
		},
		ACCOUNT_ORDER_DETAIL: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.ACCOUNT,
		},
		ACCOUNT_PASSWORD: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.ACCOUNT,
		},
		ACCOUNT_NOTIFICATIONS: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.ACCOUNT,
		},
		ACCOUNT_LANGUAGE: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.ACCOUNT,
		},
	},
	HOME: {
		CARS: {
			middleware: undefined,
			layout: EPageLayout.MAIN,
		},
	},
	RESERVATION: {
		RESERVATION: {
			middleware: undefined,
			layout: EPageLayout.RESERVATION,
		},
		COMPLETED: {
			middleware: PageMiddlewareArrays.AUTH,
			layout: EPageLayout.NAV,
		},
		CARS: {
			middleware: undefined,
			layout: EPageLayout.RESERVATION,
		},
	},
}
